import { UntypedFormControl } from '@angular/forms';

export class Utility {
  public static getIssues(issues: any): any {
    const recordIssues: any = [];
    for (const issue of issues) {
      switch (issue.trim()) {
        case 'Address Change':
          recordIssues.push('The address on record for this person is different than the uploaded value.');
          break;
        case 'Location Change':
          recordIssues.push('The location on record for this person is different than the uploaded value.');
          break;
        case 'Contribution Discrepancy?':
          recordIssues.push('The specified contribution amount is not the value expected for this person.');
          break;
        case 'New Member Enrollment':
          recordIssues.push('The person could not be identified in our records, and so is assumed to be a new enrollment.');
          break;
        case 'Zero Contribution':
          recordIssues.push('The specified amount is exactly $0.00, which may indicate a noncontributory pay.');
          break;
        case 'Annual Earnable Change':
          recordIssues.push('Annual Earnable Compensation differs from the current value by more than 20%.');
          break;
        case 'Annual Actual Change':
          recordIssues.push('Actual Annual Compensation differs from the current value by more than 20%.');
          break;
        case 'Invalid Salary':
          recordIssues.push('The specified pay period base salary is not the value expected for this person.');
          break;
      }
    }
    return recordIssues;
  }

  public static removeQuotes(data: string) {
    if (data && data !== '') {
      return data.replace(/["']/g, '');
    }
    return '';
  }

  public static lowerString(data: string) {
    if (data) {
      return data.trim().toLowerCase();
    }
    return '';
  }

  public static isValidEmail(email: string) {
    const pattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,10}$/;
    return pattern.test(this.lowerString(email));
  }

  public static getIntegers(data: string) {
    if (data) {
      const value = data.match(/\d/g);
      return value.join('');
    }
    return '';
  }

  static formatString(str: string, ...args: string[]) {
    return str.replace(/{(\d+)}/g, (match, index) => args[index] || '');
  }

  // Set hours format
  static formatHourDate(date) {
    const eodate = new Date(date.setHours(23, 59, 59, 999));
    return this.UTCTimestmpChange(eodate);
  }

  // js date to mm/dd/yyyy
  static formatDate(date: Date): string {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const;
    return new Date(date).toLocaleString('en-US', options);
  }

  // UTC date with timestemp format
  static UTCTimestmpChange(date: Date): string {
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON();
  }

  // Remove time from Date
  static removeTimeFromDate(date: any) {
    return new Date(date.substr(0, 10) + 'T00:00:00');
  }

  static removeTimeFromJSDate(date: Date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return new Date(date);
  }

  static checkNegativeAmount(value: any) {
    return value < 0 ? this.formatNegativeCurrency(value) :
      this.formatCurrency(value);
  }

  static formatNegativeCurrency(value: number) {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    const form = currencyFormatter.format(value).toString().replace('-', '(');
    return form + ')';
  }

  static formatCurrency(value: number) {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return currencyFormatter.format(value);
  }

  static formatSSN(value: any) {
    return value.substring(0, 3) + '-' + value.substring(3, 5) + '-' + value.substring(5, 9);
  }

  static invalidAlphaNumeric(control: UntypedFormControl): { [key: string]: boolean } {
    if (control.value && control.value.length && !/^[a-z0-9]+$/i.test(control.value)) {
        return { invalidAlphaNumeric: true };
    }
    return null;
}

  public static JSonTryParse(value: string) {
    try {
      return JSON.parse(value);
    } catch (e) {
      if (value === 'undefined') {
        return void 0;
      }
      return value;
    }
  }

  public static parseDate(date: any) {
    if (date) {
      if (date instanceof Date) {
        return date;
      }
      if (typeof date === 'string' || date instanceof String) {
        if (date.search(/[a-su-z+]/i) === -1) {
          date = date + 'Z';
        }
        return new Date(date);
      }
      if (typeof date === 'number' || date instanceof Number) {
        return new Date(date as any);
      }
    }
  }
}
